module.exports = __webpack_public_path__ + "static/media/logo.5e3dd5db.png";